import React from 'react';
import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';


export default function LoadingIcon({size=20, ...props}) {
  return <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />
}
